//  Core JS files -->
import "./importers/jquery";
import "../../vendor/assets/javascripts/limitless_kit/core/libraries/jquery_ui/widgets.min";
import "../../vendor/assets/javascripts/limitless_kit/core/libraries/bootstrap.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/loaders/blockui.min";
import "./importers/limitless/datatable";
import "./importers/limitless/bootbox";
import "../../vendor/assets/javascripts/limitless_kit/plugins/pickers/datepicker";
import "../../vendor/assets/javascripts/limitless_kit/plugins/pickers/color/spectrum";
import "../../vendor/assets/javascripts/limitless_kit/plugins/pickers/location/autocomplete_addresspicker";
import "../../vendor/assets/javascripts/limitless_kit/plugins/media/fancybox.min";
import { } from "../../vendor/assets/javascripts/jquery-ujs";
import "./importers/clipboard";
import "../../vendor/assets/javascripts/intlTelInput/core.min";
import "../../vendor/assets/javascripts/intlTelInput/utils";
import "./cable";
import "../../vendor/assets/javascripts/timepicker";
//  /core JS files -->

// Plugins
import "../../vendor/assets/javascripts/slick";
import "../../vendor/assets/javascripts/highcharts";
import "./importers/moment";
import "./lang/date_range_picker/fr";
import "./importers/daterangepicker";

// JqueryUI
import "../../vendor/assets/javascripts/jquery-ui/slider";
import "../../vendor/assets/javascripts/jquery-ui/tabs";
import "../../vendor/assets/javascripts/jquery-ui/accordion";
import "../../vendor/assets/javascripts/jquery-ui/sortable";

import "../../vendor/assets/javascripts/ckeditor";

//  Theme JS files -->
import "./importers/limitless/switchery";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/styling/switch.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/styling/uniform.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/selects/bootstrap_multiselect";
import "./importers/limitless/autosize";
import "../../vendor/assets/javascripts/limitless_kit/plugins/sliders/slider_pips.min";
import "./importers/limitless/moment";
import "../../vendor/assets/javascripts/limitless_kit/plugins/ui/nicescroll.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/selects/select2.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/tags/tagsinput.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/tags/tokenfield.min";
import "./importers/pnotify";
import "../../vendor/assets/javascripts/pnotify/pnotify.buttons";
import "../../vendor/assets/javascripts/pnotify/pnotify.nonblock";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/validation/validate.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/validation/localization/messages_fr.min";

import "../../vendor/assets/javascripts/limitless_kit/core/app";

import "./commons/utils";
import "./commons/uploader";
import "./commons/search_filter";
import "./commons/search_filter_ajax";
import "./commons/calendly_module";
import "./commons/modernizr";
import "./commons/deviceQueries";
import "./commons/value_switcher";
import "./commons/share_events";
import "./commons/emoji_picker";

// Commons
import "./customer_space/commons/limitless_plugins";
import "./customer_space/commons/limitless_plugins_initializer";

import "./customer_space/commons/modules";
import "./customer_space/commons/modules_initializer";

import "./customer_space/commons/plugins_initializer";

import "./customer_space/commons/confirm";
import "./customer_space/commons/loader";
import "./customer_space/commons/steps_loader";
import "./customer_space/commons/select_follower";
import "./customer_space/commons/modal";
import "./customer_space/commons/modals";
import "./customer_space/commons/daterangepicker";
import "./customer_space/commons/date_range_picker";
import "./customer_space/commons/forms";
import "./customer_space/commons/export_excel_action_cable";
import "./customer_space/commons/ckeditor";
import "./customer_space/commons/calendly_iframe";
import "./customer_space/commons/charts_frequency";
import "./customer_space/commons/highcharts_chart";
import "./customer_space/commons/video";

import "./stimulus/customer_space";

// Modals

//SiteProjects
import "./customer_space/modals/site_projects/interactions/modal_interactions_form_submissions_excel_export";
import "./customer_space/modals/site_projects/creation_form_submission_funnel/modal_creation_form_submission_funnel";
import "./customer_space/modals/site_projects/creation_form_submission_funnel/modal_specific_logo";
import "./customer_space/modals/site_projects/creation_form_submission_funnel/modal_add_specific_thematics";
import "./customer_space/modals/site_projects/creation_form_submission_funnel/modal_one_specific_thematic";
import "./customer_space/modals/site_projects/creation_form_submission_funnel/modal_add_one_pricing";
import "./customer_space/modals/site_projects/creation_form_submission_funnel/modal_library_items_selection";
import "./customer_space/modals/site_projects/creation_form_submission_funnel/modal_thematics_selection";
import "./customer_space/modals/site_projects/creation_form_submission_funnel/modal_custom_items_list";

// MainController
import "./customer_space/main_controller";

// LocalManagement
import "./customer_space/local_management/modules";
import "./customer_space/local_management/modals";
import "./customer_space/local_management/controllers/main_controller";
import "./customer_space/local_management/controllers/dashboard_controller";
import "./customer_space/local_management/controllers/hour_periods_controller";
import "./customer_space/local_management/controllers/special_hour_periods_controller";
import "./customer_space/local_management/controllers/faq_questions_controller";
import "./customer_space/local_management/controllers/contact_controller";
import "./customer_space/local_management/controllers/online_services_controller";
import "./customer_space/local_management/controllers/services_controller";
import "./customer_space/local_management/controllers/general_controller";
import "./customer_space/local_management/controllers/appointment_controller";
import "./customer_space/local_management/controllers/complementary_services_controller";
import "./customer_space/local_management/controllers/multicast/apple_business_connect_controller";
import "./customer_space/local_management/controllers/multicast/google_mybusiness_controller";
import "./customer_space/local_management/controllers/multicast/platforms_controller";
import "./customer_space/local_management/controllers/multicast/validation_documents_folder_controller";
import "./customer_space/local_management/controllers/optimization_controller";
import "./customer_space/local_management/controllers/form_submission_funnel/start_controller";
import "./customer_space/local_management/controllers/unsubscription_requests_controller";

// Location
import "./customer_space/location/controllers/main_controller";
import "./customer_space/location/controllers/unsubscription_requests_controller";

import "./customer_space/social/modals";
import "./customer_space/social/controllers/main_controller";
import "./customer_space/social/controllers/social_posts_form_controller";

// Websites
import "./customer_space/websites/modules";
import "./customer_space/websites/modals";
import "./customer_space/websites/controllers/main_controller";
import "./customer_space/websites/controllers/creation_form_submission_funnel_controller";
import "./customer_space/websites/controllers/designs_propositions_selection_controller";
import "./customer_space/websites/controllers/legal_notice_form_submission_controller";
import "./customer_space/websites/controllers/texts_collection_requests_controller";
import "./customer_space/websites/controllers/faq_questions_controller";
import "./customer_space/websites/controllers/faq_categories_controller";
import "./customer_space/websites/controllers/online_jump_projects_controller";
import "./customer_space/websites/controllers/local_site_projects_dashboard_controller";
import "./customer_space/websites/controllers/blog_articles_controller";
import "./customer_space/websites/controllers/conversions_controller";

// Media
import "./customer_space/media/modals";

// Emailing
import "./customer_space/emailing/modals";
import "./customer_space/emailing/controllers/main_controller";
import "./customer_space/emailing/controllers/recurring_settings_content_controller";
import "./customer_space/emailing/controllers/crm_lists_controller";
import "./customer_space/emailing/controllers/deliveries_controller";

// GoogleMyBusiness
import "./customer_space/google_my_business/modules";
import "./customer_space/google_my_business/modals";
import "./customer_space/google_my_business/controllers/main_controller";
import "./customer_space/google_my_business/controllers/attributes_controller";
import "./customer_space/google_my_business/controllers/regular_hours_controller";
import "./customer_space/google_my_business/controllers/special_hours_controller";

// Reviews
import "./customer_space/reviews/modules";
import "./customer_space/reviews/modals";
import "./customer_space/reviews/controllers/main_controller";
import "./customer_space/reviews/controllers/requests_controller";

// Statistics
import "./customer_space/statistics/modules";
import "./customer_space/statistics/controllers/main_controller";
import "./customer_space/statistics/controllers/websites/search_keywords_controller";
import "./customer_space/statistics/controllers/websites/analytics_controller";
import "./customer_space/statistics/controllers/websites/conversions_controller";
import "./customer_space/statistics/controllers/websites/blog_controller";
import "./customer_space/statistics/controllers/reviews/e_reputation_controller";
import "./customer_space/statistics/controllers/google_my_business/e_reputation_controller";
import "./customer_space/statistics/controllers/google_my_business/performance_controller";
import "./customer_space/statistics/controllers/webdirectories/performance_controller";

// Settings
import "./customer_space/settings/modules";
import "./customer_space/settings/modals";
import "./customer_space/settings/controllers/main_controller";
import "./customer_space/settings/controllers/general_controller";
import "./customer_space/settings/controllers/email_signature_builder_controller";
import "./customer_space/settings/controllers/social_design_controller";
import "./customer_space/settings/controllers/emailing_recurring_settings_controller";
import "./customer_space/settings/controllers/location_marketing_profile_controller";
import "./customer_space/settings/controllers/reviews_controller";
import "./customer_space/settings/controllers/booking_hour_periods_controller";
import "./customer_space/settings/controllers/booking_settings_controller";

// TasksProjects
import "./customer_space/tasks_projects/modals";
import "./customer_space/tasks_projects/modules";

// Account
import "./customer_space/account/modules";
import "./customer_space/account/modals";
import "./customer_space/account/controllers/main_controller";
import "./customer_space/account/controllers/account_controller";
import "./customer_space/settings/crm/controllers/bulk_contact_deletions_controller";
import "./customer_space/account/controllers/unsubscription_requests_controller";

// History
import "./customer_space/history/modals";

// Sponsoring
import "./customer_space/sponsoring/modules";
import "./customer_space/sponsoring/controllers/main_controller";
import "./customer_space/sponsoring/controllers/manage_controller";
import "./customer_space/sponsoring/controllers/faq_controller";

// Nps
import "./customer_space/nps/controllers/nps_submissions_controller";

// Profile
import "./customer_space/profile/controllers/contact_controller";

// Public
import "./customer_space/public/modals";
import "./customer_space/public/controllers/main_controller";
import "./customer_space/public/controllers/welcome_new_account_funnel_controller";
import "./customer_space/public/controllers/welcome_remote_audits_funnel_controller";
import "./customer_space/public/controllers/welcome_local_management_discovery_funnel_controller";
import "./customer_space/public/controllers/welcome_email_signature_builder_controller";
import "./customer_space/public/controllers/welcome_emailing_builder_controller.js";
import "./customer_space/partials/modals/variable_picker.js";

// Help
import "./customer_space/help/controllers/main_controller";

// Dashboard
import "./customer_space/dashboard/controllers/main_controller";

// Router
import "./customer_space/router";
